
export const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];


export const firstArrMinute = [5, 10, 15, 20, 25, 30, 40, 45];

export const lastArrMinute = [50, 55, 60, 65, 70, 75, 80, 85, 90]


export function formatPrice(number) {
    return number.toLocaleString('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 })
}